export default "__VITE_ASSET__IC9EPHPP__"